module.exports = __webpack_public_path__ + "static/media/nurseBg.de827ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurseBg.png
// module id = 499
// module chunks = 0